// extracted by mini-css-extract-plugin
export default {"StickyBlock":"bfa_a bia_bj"};